export const ParkingStatus = () => null;

ParkingStatus.propTypes = {};
